export const getImageByBreakpoint = (mediaImage) => {
  const imageByBreakpoint = {}
  for (const minWidth in mediaImage) {
    if (mediaImage[minWidth] != null && minWidth !== 'Url' && minWidth.startsWith('Url')) {
      const newMinWidth = minWidth.replace(/\D/g, '') + 'px'
      imageByBreakpoint[newMinWidth] = mediaImage[minWidth]
    }
  }
  return imageByBreakpoint
}
